import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/404-error.svg'


const _hoisted_1 = { class: "w-full h-screen" }
const _hoisted_2 = { class: "h-full bg-background flex flex-col justify-center items-center" }
const _hoisted_3 = { class: "flex flex-col justify-center items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-56"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mb-8 font-medium" }, "This page doesn't exist", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-7 w-7",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "11",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "11",
    y2: "6"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_Button, {
          variant: "contained",
          label: "Go back",
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, {
          startIcon: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}